import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svgs/icons/arrow_botton.svg'
import _imports_1 from '@/assets/svgs/icons/slip.svg'
import _imports_2 from '@/assets/svgs/icons/doc.svg'


const _withScopeId = n => (_pushScopeId("data-v-41260d22"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-header-card" }, "Reward", -1))
const _hoisted_2 = {
  key: 0,
  class: "tooltipBox"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("รายการจะขึ้นแสดงก็ต่อเมื่อยอดของรายการนั้นมีจำนวนครบ 1,000 บาท สามารถอ่านรายละเอียดเพิ่มเติ่มที่ "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "qna-link",
    target: "_blank",
    href: "https://coda.io/d/Affiliate_dYCNrxPk1EO/Affiliate_suj-94yq#_luaqBZZ4"
  }, " Q&Aคำถามที่พบบ่อย ")
], -1))
const _hoisted_5 = {
  key: 1,
  class: "tooltipBox"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "การต่ออายุแพ็กเกจ จะแสดงรายการที่ข้อมูลการชำระ สถานะเป็น “สำเร็จ” เท่านั้น ซึ่งใช้เวลาไม่เกิน 3 วันทำการหลังต่ออายุ", -1))
const _hoisted_8 = {
  style: {"overflow":"auto"},
  class: "mt-5"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_10 = {
  class: "filter",
  style: {"justify-content":"start"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Campaign Name", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "SVG Image"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "text-center"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Error Found.", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "filter" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  class: "filter",
  style: {"justify-content":"end"}
}
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"end"} }, "VAT (THB)", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"end"} }, "WHT (THB)", -1))
const _hoisted_24 = {
  key: 1,
  style: {"text-align":"start"}
}
const _hoisted_25 = {
  key: 2,
  style: {"text-align":"center"}
}
const _hoisted_26 = {
  key: 3,
  style: {"text-align":"center","min-width":"50px"}
}
const _hoisted_27 = { style: {"text-align":"start"} }
const _hoisted_28 = ["title", "onClick"]
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "text-right" }
const _hoisted_32 = { style: {"text-align":"end"} }
const _hoisted_33 = { style: {"text-align":"end"} }
const _hoisted_34 = {
  key: 1,
  class: "text-start"
}
const _hoisted_35 = { key: 2 }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 1,
  class: "paid-action"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "slip"
}, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#3297ff"} }, "Slip", -1))
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "px-2 py-3",
  style: {"font-size":"25px"}
}, "Payment Slip", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_43 = { class: "rounded-sm transfer" }
const _hoisted_44 = { class: "font-weight-bold" }
const _hoisted_45 = {
  key: 2,
  class: "w-100 text-center"
}
const _hoisted_46 = ["title"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_48 = { class: "d-flex" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "slip"
}, null, -1))
const _hoisted_51 = { key: 3 }
const _hoisted_52 = {
  key: 0,
  class: "d-flex justify-center"
}
const _hoisted_53 = { class: "d-flex justify-center align-center" }
const _hoisted_54 = {
  key: 1,
  class: "error"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "font-weight-bold",
  style: {"font-size":"1rem"}
}, "Error Found", -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = {
  key: 2,
  class: "no-data"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "font-weight-bold",
  style: {"font-size":"1rem"}
}, "No Data", -1))
const _hoisted_59 = [
  _hoisted_58
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VTab = _resolveComponent("VTab")!
  const _component_VButton = _resolveComponent("VButton")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_InputCheckBox = _resolveComponent("InputCheckBox")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_PreviewPdf = _resolveComponent("PreviewPdf")!
  const _component_PreviewImage = _resolveComponent("PreviewImage")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_RewardAction = _resolveComponent("RewardAction")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "container" }, {
        default: _withCtx(() => [
          _createVNode(_component_VTab, {
            style: _normalizeStyle(_ctx.getWindowsSize['x'] < 600 ? { marginLeft: '10px', marginRight: '10px' } : '100%'),
            data: _ctx.tabReward,
            onMenu: _ctx.onChangeActiveTabs,
            active: _ctx.rewardsFilter.status
          }, null, 8, ["style", "data", "onMenu", "active"]),
          (_ctx.getWindowsSize['x'] > 1100)
            ? (_openBlock(), _createBlock(_component_VButton, {
                key: 0,
                message: 'Export',
                radius: '20px',
                bgColor: '#fff',
                bgBorder: '1px solid #dadbe6',
                width: '10rem',
                src: require('@/assets/svgs/icons/csv.svg'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.DoExportExcelReward()))
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "container" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "pa-0 mt-10 col align-center",
            style: _normalizeStyle(_ctx.getWindowsSize['x'] < 600 ? { marginLeft: '10px', marginRight: '10px' } : '100%')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DatePicker, {
                label: 'From Date - To Date',
                width: _ctx.getWindowsSize['x'] < 1100 ? '100%' : '100%',
                widthContent: _ctx.getWindowsSize['x'] < 1100 ? '100%' : '40rem',
                disable: _ctx.rewards.length > 0,
                onSearch: _ctx.onSearch
              }, null, 8, ["width", "widthContent", "disable", "onSearch"]),
              (String(_ctx.rewardsFilter.status) === 'All')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("img", {
                      src: _ctx.info_circle_solid,
                      alt: "info_circle_solid"
                    }, null, 8, _hoisted_3),
                    _hoisted_4
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("img", {
                      src: _ctx.info_circle_solid,
                      alt: "info_circle_solid"
                    }, null, 8, _hoisted_6),
                    _hoisted_7
                  ]))
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        class: "container pl-3 pr-3",
        style: {"justify-content":"end"}
      }, {
        default: _withCtx(() => [
          (_ctx.getWindowsSize['x'] < 1100)
            ? (_openBlock(), _createBlock(_component_VButton, {
                key: 0,
                style: {"margin-top":"10px"},
                message: 'Export',
                radius: '20px',
                bgColor: '#fff',
                bgBorder: '1px solid black',
                width: '10rem',
                src: require('@/assets/svgs/icons/csv.svg')
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_9,
              _createElementVNode("th", null, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onToggle = !_ctx.onToggle))
                  }, _hoisted_13),
                  _createElementVNode("ul", {
                    class: _normalizeClass([{ show: _ctx.onToggle }, "hidden text-left"])
                  }, [
                    (_ctx.campaignDropdown.length > 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_InputCheckBox, {
                            label: 'Select All',
                            "sync-data": 'All',
                            selected: !!_ctx.selected.find((item) => item === 'All'),
                            onChecked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeGoalFilter('All', $event))),
                            onUnChecked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeGoalFilter('All', $event)))
                          }, null, 8, ["selected"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignDropdown, (item, index) => {
                            return (_openBlock(), _createBlock(_component_InputCheckBox, {
                              key: index,
                              label: item.nameCampaign,
                              selected: !!_ctx.selected.find((value) => value === item.campaignCode),
                              title: item.nameCampaign,
                              onChecked: ($event: any) => (_ctx.onChangeGoalFilter(item.campaignCode, $event)),
                              onUnChecked: ($event: any) => (_ctx.onChangeGoalFilter(item.campaignCode, $event))
                            }, null, 8, ["label", "selected", "title", "onChecked", "onUnChecked"]))
                          }), 128))
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.campaignDropdown.length < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                      : _createCommentVNode("", true)
                  ], 2)
                ])
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("div", _hoisted_17, [
                  _createTextVNode(" Processing Date "),
                  _createElementVNode("img", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortProcessingDate())),
                    src: _ctx.$data[_ctx.sortIconProcessingDate],
                    alt: ""
                  }, null, 8, _hoisted_18)
                ])
              ]),
              (String(_ctx.rewardsFilter.status) === 'Pending')
                ? (_openBlock(), _createElementBlock("th", _hoisted_19, "Requested Date"))
                : _createCommentVNode("", true),
              _createElementVNode("th", null, [
                _createElementVNode("div", _hoisted_20, [
                  _createTextVNode(" Reward (THB) "),
                  _createElementVNode("img", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortReward())),
                    src: _ctx.$data[_ctx.sortIconReward],
                    alt: "sort"
                  }, null, 8, _hoisted_21)
                ])
              ]),
              _hoisted_22,
              _hoisted_23,
              (String(_ctx.rewardsFilter.status) === 'All')
                ? (_openBlock(), _createElementBlock("th", _hoisted_24, "Status"))
                : _createCommentVNode("", true),
              (String(_ctx.rewardsFilter.status) === 'Request' || String(_ctx.rewardsFilter.status) === 'Paid')
                ? (_openBlock(), _createElementBlock("th", _hoisted_25, " Action "))
                : _createCommentVNode("", true),
              (String(_ctx.rewardsFilter.status) === 'All')
                ? (_openBlock(), _createElementBlock("th", _hoisted_26))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rewards, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: _normalizeClass({ 'line-end': index === _ctx.rewards.length - 1 })
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.numberHeader(index + 1)), 1)
                ]),
                _createElementVNode("td", _hoisted_27, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      style: {"width":"20rem"},
                      class: "ellipsis blue",
                      title: item.nameCampaign,
                      onClick: ($event: any) => (_ctx.routingCampaigns(item.codeCampaign))
                    }, _toDisplayString(item.nameCampaign), 9, _hoisted_28)
                  ])
                ]),
                _createElementVNode("td", _hoisted_29, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.onChangeFormatDate(item.processingDate) || "-"), 1)
                ]),
                (String(_ctx.rewardsFilter.status) === 'Pending')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.onChangeFormatDate(item.requestDate) || "-"), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_31, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.addComma(item.rewardAmount || "0", { toFixed: 2 })), 1)
                ]),
                _createElementVNode("td", _hoisted_32, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.addComma(item.vat || "0", { toFixed: 2 })), 1)
                ]),
                _createElementVNode("td", _hoisted_33, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.addComma(item.wht || "0", { toFixed: 2 })), 1)
                ]),
                (String(_ctx.rewardsFilter.status) === 'All')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_34, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.getStatus(item.status)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (String(_ctx.rewardsFilter.status) === 'Request' || String(_ctx.rewardsFilter.status) === 'Paid')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_35, [
                      (String(_ctx.rewardsFilter.status) === 'Request')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createVNode(_component_VButton, {
                              onClick: ($event: any) => (_ctx.onChangeStatusRequest(item.id)),
                              message: 'Request',
                              bgColor: '#3DC0CB',
                              fontColor: 'white',
                              radius: '20px',
                              width: '7rem'
                            }, null, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      (String(_ctx.rewardsFilter.status) === 'Paid')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            (item.slip)
                              ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "auto" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_dialog, {
                                          transition: "dialog-bottom-transition",
                                          width: "700"
                                        }, {
                                          activator: _withCtx(({ props }) => [
                                            _createElementVNode("div", _mergeProps({ style: {"display":"flex","gap":"10px","cursor":"pointer"} }, props), _hoisted_40, 16)
                                          ]),
                                          default: _withCtx(({ isActive }) => [
                                            _createVNode(_component_v_card, {
                                              "max-width": "700",
                                              rounded: "lg"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, null, {
                                                  default: _withCtx(() => [
                                                    _hoisted_41
                                                  ]),
                                                  _: 1
                                                }),
                                                _hoisted_42,
                                                _createVNode(_component_v_card_text, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_43, [
                                                      _createElementVNode("p", _hoisted_44, " Transfer Date : " + _toDisplayString(_ctx.onChangeFormatDate(item.transferDate)), 1)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_card_text, {
                                                  class: "w-100 d-flex align-center justify-center overflow-hidden",
                                                  style: {"height":"500px","background-color":"#333","padding":"0"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    (item.slip.includes('pdf'))
                                                      ? (_openBlock(), _createBlock(_component_PreviewPdf, {
                                                          key: 0,
                                                          fileUrl: item.slip,
                                                          toolBar: true
                                                        }, null, 8, ["fileUrl"]))
                                                      : (_ctx.isImage(item.slip))
                                                        ? (_openBlock(), _createBlock(_component_PreviewImage, {
                                                            key: 1,
                                                            imgUrl: item.slip,
                                                            toolBar: true
                                                          }, null, 8, ["imgUrl"]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                            _createElementVNode("i", {
                                                              class: _normalizeClass([_ctx.getIconByFileName(_ctx.getFileName(item.slip)).icon, "fileIcon"]),
                                                              style: _normalizeStyle(`color: ${_ctx.getIconByFileName(_ctx.getFileName(item.slip)).color};`),
                                                              title: _ctx.getFileName(item.slip)
                                                            }, null, 14, _hoisted_46)
                                                          ]))
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _hoisted_47,
                                                _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_48, [
                                                      _createVNode(_component_VButton, {
                                                        onClick: ($event: any) => (isActive.value = false),
                                                        message: 'Close',
                                                        bgBorder: '1px solid #DADBE6',
                                                        fontColor: '#3B3C66',
                                                        radius: '20px',
                                                        width: '100px'
                                                      }, null, 8, ["onClick"]),
                                                      _createVNode(_component_VButton, {
                                                        onClick: ($event: any) => (_ctx.onDownloadSlip(item.slip)),
                                                        message: 'Downlaod',
                                                        bgColor: '#3DC0CB',
                                                        fontColor: 'white',
                                                        radius: '20px',
                                                        width: '100px'
                                                      }, null, 8, ["onClick"])
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (item.whtUrl)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  style: _normalizeStyle([{"display":"flex","gap":"10px","cursor":"pointer"}, { filter: item.whtUrl ? 'grayscale(0%)' : 'grayscale(100%)' }]),
                                  onClick: ($event: any) => (_ctx.openLinkInNewTab(item.whtUrl))
                                }, [
                                  _hoisted_50,
                                  _createElementVNode("p", {
                                    style: _normalizeStyle({ color: item.whtUrl ? '#3297ff' : '#a1a1a1' })
                                  }, "WHT", 4)
                                ], 12, _hoisted_49))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (String(_ctx.rewardsFilter.status) === 'All')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_51, [
                      _createVNode(_component_RewardAction, {
                        rewardTransactionMonthlyId: item.id
                      }, null, 8, ["rewardTransactionMonthlyId"])
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ])
        ]),
        (_ctx.isLoadingTableREward)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [
              _createElementVNode("td", _hoisted_53, [
                _createVNode(_component_v_progress_circular, {
                  class: "mt-5",
                  color: "#3B3C66",
                  indeterminate: "",
                  width: 3,
                  size: 25
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isErrorTableReward)
          ? (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_56))
          : _createCommentVNode("", true),
        (_ctx.isNoDataTableReward)
          ? (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_59))
          : _createCommentVNode("", true),
        _createVNode(_component_Pagination, {
          style: {"margin-top":"10rem"},
          justifyContent: _ctx.getWindowsSize['x'] < 600 ? 'center' : 'flex-end',
          data: _ctx.rewardsFilter.pagination,
          totalPage: _ctx.pagination.totalPages,
          onPage: _ctx.pageNow,
          onPerPageEvent: _ctx.changeNumberPerPage,
          onLength: _ctx.changeLength
        }, null, 8, ["justifyContent", "data", "totalPage", "onPage", "onPerPageEvent", "onLength"])
      ])
    ]),
    _: 1
  }))
}